import React from "react"
import Error from "next/error"
import ExhibitionDetailsPage from "../../features/pages/ExhibitionDetailsPage"
import galleryApiService from "../../services/galleryApiService"

const ExhibitionDetails = ({ exhibitionDetails, errorCode }) => {
  if (errorCode) {
    return <Error statusCode={errorCode} />
  }
  return <ExhibitionDetailsPage exhibitionDetails={exhibitionDetails} />
}

export const getServerSideProps = async ({ params }) => {
  const response = await galleryApiService
    .exhibition(params.id)
    .then((res) => {
      return res
    })
    .catch((err) => {
      return err.response
    })

  const errorCode = response.statusText == "OK" ? false : response.status

  return {
    props: {
      errorCode: errorCode,
      exhibitionDetails: response.data,
    },
  }
}

export default ExhibitionDetails
